import { Api } from '../../Api';
import { IServiceLookupDto } from './interfaces';

export class Lookups {
    private static _basePath = '/lookups';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${Lookups._basePath}`;
        return {
            async get() {
                const path = '/';
                return await Api.get<IServiceLookupDto[]>({
                    path: `${basePath}${path}`,
                });
            },
        };
    }
}
